import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const laboratoryCabinet = {
    path: '/laboratory-cabinet',
    component: Layout,
    name: 'laboratoryCabinet',
    redirect: '/laboratory-cabinet/patients',
    children: [
      {
        path: '/laboratory-cabinet/patients',
        component: () => import('@/views/laboratoryCabinet/patients'),
        name: 'laboratory-cabinet.patients',
        meta: { title: i18n.t(`message.my_office`)}
      },
      {
        path: '/laboratory-cabinet/informal-patients',
        component: () => import('@/views/laboratoryCabinet/informal-patients'),
        name: 'laboratory-cabinet.informal-patients',
        meta: { title: i18n.t(`message.my_office`)}
      },
      {
        path: '/laboratory-cabinet/AllPatients',
        component: () => import('@/views/laboratoryCabinet/AllPatients'),
        name: 'laboratory-cabinet.AllPatients',
        meta: { title: i18n.t(`message.patients`)}
      },
    ]
  }

export default laboratoryCabinet